<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-3">
        <button
          type="button"
          class="btn btn-success btn-block"
          @click="getReport"
        >
          <i class="fas fa-redo"></i> ประมวลผล
        </button>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/pdf/report_sale_hold_detail.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-primary btn-block"
          >
            <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
          </button>
        </form>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/excel/report_sale_hold_detail.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-info btn-block"
          >
            <i class="far fa-file-excel"></i> บันทึกเป็น Excel
          </button>
        </form>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <div class="table-responsive-sm mt-3">
      <table
        class="table"
        v-for="(d, i) in report_data"
        v-show="d.length > 0"
        :key="'branchData' + i"
      >
        <thead>
          <tr class="head-branch text-left" >
            <th colspan="3">สาขา: {{ (d.length > 0)? d[0].branch_name : '-' }}</th>
            <th colspan="2">จุดขาย: {{ host.host_name }}</th>
            <th colspan="3">วันที่: <span>{{ dateFormatDMY(startDate) }}</span>
              <span v-if="dateFormatDMY(startDate) !== dateFormatDMY(endDate)">ถึง วันที่: {{ dateFormatDMY(endDate) }}</span>
            </th>
          </tr>
        </thead>
        <tbody
          v-for="(r, i) in d"
          :key="'datar' + i"
        >
          <tr class="text-left thead-dark head_table">
            <td colspan="4">เลขที่ใบเสร็จ: {{ r.doc_no }}</td>
             <td>
              ประเภท: พักบิล
            </td>
            <td>เวลา: {{ dateFormatAndTime(r.create_time) }}</td>
            <td class="text-right">ส่วนลดใบเสร็จ: {{ numberFormatDecimal(r.discount_amount) }}</td>
            <td
              class="text-right"
            >เฉพาะราคาขาย: all</td>
          </tr>
          <tr class="thead-dark head_datail">
            <th width="15%">บาร์โค้ด</th>
            <th width="20%" class="text-left">รายละเอียด</th>
            <th width="10%" class="text-right">ราคาขาย/หน่วยนับ</th>
            <th width="10%" class="text-right">จำนวน</th>
            <th width="10%" class="text-right">ส่วนลด</th>
            <th width="10%" class="text-right">ราคาก่อน VAT</th>
            <th width="15%" class="text-right">ภาษี 7%</th>
            <th width="20%" class="text-right">ราคารวม</th>
          </tr>
          <tr
            v-for="(sub, i) in r.sub"
            :key="'subs' + i"
          >
            <td class="text-center">{{ sub.item_barcode }}</td>
            <td class="text-left">{{ sub.item_name }}</td>
            <td class="text-right">{{ numberFormatDecimal(sub.price) }}</td>
            <td class="text-right">{{ numberFormatDecimal(sub.cn_qty) }}</td>
            <td class="text-right">0.00</td>
            <td class="text-right">{{ numberFormatDecimal(sub.amount - sub.tax_amount) }}</td>
            <td class="text-right">{{ numberFormatDecimal(sub.tax_amount) }}</td>
            <td class="text-right">{{ numberFormatDecimal(sub.amount) }}</td>
          </tr>
          <tr>
            <th
              colspan="3"
              class="text-left"
            >ลูกค้า: {{ r.ar_name || '-'}} / หมายเหตุ: {{ r.description || '-'}}</th>
            <th
              colspan="5"
              class="text-right"
            >### รวมรายการสินค้าจำนวน: {{ r.sub.length }} ###</th>
          </tr>
          <tr class="thead-footer">
            <td
              colspan="3"
              class="text-left"
            >พนักงานเก็บเงิน: {{ r.create_by }}</td>
            <th class="text-right">{{ numberFormatDecimal(sum_qty(r.sub)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(0) }}</th>
            <th class="text-right">{{ numberFormatDecimal(r.total_amount - r.cal_product_tax) }}</th>
            <th class="text-right">{{ numberFormatDecimal(r.cal_product_tax) }}</th>
            <th class="text-right">{{ numberFormatDecimal(r.total_amount) }}</th>
          </tr>
        </tbody>
        <tbody>
          <tr class="table-secondary" style="font-size: 20px;">
            <th
              colspan="7"
              class="text-left"
            >รวมสาขา: {{ (d.length > 0)? d[0].branch_name : '-' }}</th>
            <th class="text-right">{{ numberFormatDecimal(sum_total(d)) }}</th>
          </tr>
        </tbody>
        <tbody v-if="report_data.length === 0">
          <tr>
            <th
              scope="row"
              colspan="6"
            >ไม่มีข้อมูล</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../../services/service_report'

export default {
  props: ['host', 'startDate', 'endDate', 'branch', 'startTime', 'endTime'],
  data () {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: JSON.stringify(this.host)
    }
  },
  methods: {
    getReport () {
      var branch = 0
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateDMY(this.startDate) + ' ' + this.startTime,
        end_date: this.dateDMY(this.endDate) + ' ' + this.endTime
      }
      this.$store.commit('Loading')
      api.saleHoldDetail(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.report_data = result.data
            this.form_data = JSON.stringify(result.data)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          this.$notification['warning']({
            message: 'ไม่สามารถเข้าถึงข้อมูล',
            description: 'API น่าจะ panic'
          })
          console.log('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    sum_qty (obj) {
      var sumQty = 0
      obj.forEach(val => {
        sumQty += val['cn_qty']
      })
      return sumQty
    },
    sum_total (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['total_amount']
      })
      return sum
    }
  },
  mounted () {
    // this.getReport()
  }
}
</script>

<style scoped>

.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
   font-weight: bold;
}
.table .thead-dark th {
    color: #000000;
    text-align: center;
    background-color: #6599ff;
    border-color: #383f45;
}
.table .thead-footer th {
    color: #000000;
    text-align: center;
    background-color: #ffff;
}
</style>



// WEBPACK FOOTER //
// src/components/report/report_sale_hold_detail.vue